// @flow

import * as React from "react"
import type { Coords } from "shared/types/Coords"
import {
  Map,
  Group,
  ToMarker,
  FromMarker,
  Marker,
  ViaMarker
} from "@cabonline/here-maps"
import carIcon from "shared/components/icons/CarMarker"

type Props = {
  from: ?Coords,
  to: ?Coords,
  via: ?Array<Coords>,
  locked: boolean,
  vehiclePosition?: Coords,
  isAnimatedPath: boolean,
  departureTime?: string
}

const TrackedMap = (props: Props): React$Element<any> => {
  return (
    <Map locked={props.locked}>
      <Group
        centerToBounds
        withPulse={props.isAnimatedPath}
        departureTime={props.departureTime}
      >
        {props.from && <FromMarker lat={props.from.lat} lng={props.from.lng} />}
        {props.to && <ToMarker lat={props.to.lat} lng={props.to.lng} />}
        {props.via &&
          props.via.length > 0 &&
          props.via.map((obj, index) => (
            <ViaMarker key={index} lat={obj.lat} lng={obj.lng} />
          ))}
      </Group>
      {props.vehiclePosition && (
        <Marker lat={props.vehiclePosition.lat} lng={props.vehiclePosition.lng}>
          {carIcon}
        </Marker>
      )}
    </Map>
  )
}

export default TrackedMap
